// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// 处理页面 Added non-passive event listener to a scroll-blocking 'mousewheel' event.   警告问题
import 'default-passive-events'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echarts from 'echarts'

//引入自定义指令permission
import './utils/permission.js'

import App from './App'
import router from './router'
import store from './store/index'
import api from './api' // 导入api接口
import './assets/manageicon/iconfont.css'
import '@/assets/css/font.css';

import moment from 'moment'; //导入模块
moment.locale('zh-cn'); //设置语言 或 moment.lang('zh-cn'); 
Vue.prototype.$moment = moment;//赋值使用
Vue.use(ElementUI);
ElementUI.Dialog.props.closeOnClickModal.default = false; 
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
// 复制插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 导出插件
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
Vue.prototype.$api = api; // 将api挂载到vue的原型上
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js